<template>
  <div id="rank_comparison_table">
    <div>百分計分與等第計分對應標準表 :</div>
    <div class="rank_table_holder">
      <table>
        <thead>
          <tr>
            <th>等第計算法</th>
            <th>積分(GP值)</th>
            <th>百分計分法</th>
            <th>百分制分數區間中位數</th>
            <th style="width: 30%; min-width: 120px;">備註</th>
          </tr>
        </thead>
        <tbody>
          <tr> <td>A+</td> <td>4.0</td> <td>100~90</td> <td>95</td> <td>達成學習目標，且表現優異</td> </tr>
          <tr> <td>A</td> <td>4.0</td> <td>89~85</td> <td>87</td> <td>達成學習目標</td> </tr>
          <tr> <td>A-</td> <td>3.7</td> <td>84~80</td> <td>82</td> <td>雖達成學習目標，但需再精進</td> </tr>
          <tr> <td>B+</td> <td>3.3</td> <td>79~77</td> <td>78</td> <td>達成部分目標，且品質佳</td> </tr>
          <tr> <td>B</td> <td>3.0</td> <td>76~73</td> <td>75</td> <td>達成部分目標</td> </tr>
          <tr> <td>B-</td> <td>2.7</td> <td>72~70</td> <td>71</td> <td>雖達成部分目標，但需要精進 (研究生及格標準)</td> </tr>
          <tr> <td>C+</td> <td>2.3</td> <td>69~67</td> <td>68</td> <td>達成最低目標</td> </tr>
          <tr> <td>C</td> <td>2.0</td> <td>66~63</td> <td>65</td> <td>雖達成最低目標，但需精進</td> </tr>
          <tr> <td>C-</td> <td>1.7</td> <td>62~60</td> <td>61</td> <td>達成最低目標，但有重大缺失 (大學部及格標準)</td> </tr>
          <tr> <td>D</td> <td>1.0</td> <td>59~50</td> <td>55</td> <td>雖未達最低目標，但可再研修</td> </tr>
          <tr> <td>E</td> <td>0.0</td> <td><50</td> <td>49</td> <td>未達最低目標，不核 予成績</td> </tr>
          <tr> <td>x</td> <td>-</td> <td>-</td> <td>-</td> <td>因故不予評分</td> </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RankComparisonTable',
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  #rank_comparison_table .rank_table_holder { text-align: center; overflow: auto; }
  #rank_comparison_table table tr { height: 45px; border-bottom: 1px solid #70707036; }
  #rank_comparison_table table thead tr { border-color: #707070cc; }
  #rank_comparison_table table thead th { padding: 0 10px; white-space: nowrap; }
</style>
